<template>
  <a  v-if="!isExpired"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
  >
    <div class="promotion-banner" :style="{ backgroundColor: bgColor }">
      <h3 class="title">{{ title }}</h3>
      <span class="link">
        <span>자세히 보기</span>
        <img src="@/assets/images/icon/ico_view2_b.svg"/>
      </span>
    </div>
  </a>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  link: String,
  title: String,
  bgColor: String,
  period: String, // 'YYYY-MM-DD'
})

const isExpired = computed(() => {
  const deadline = new Date(props.period + 'T23:59:59')
  const now = new Date()
  return now >= deadline
})
</script>

<style scoped>
.promotion-banner {
  height: 33px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.promotion-banner .title {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.promotion-banner .link {
  font-weight: 400;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.promotion-banner .link span {
  font-size: 12px;
  line-height: 1;
}

.promotion-banner .link img {
  vertical-align: middle;
  width: 5px; /* 필요시 크기 고정 */
  height: 10px;
}

@media all and (max-width: 460px) {
  .promotion-banner {
    height: 25px;
    gap: 5px;
  }

  .promotion-banner .title {
    font-size: 12px;
  }

  .promotion-banner .link span {
    font-size: 10px;
  }

  .promotion-banner .link img {
    width: 4px;
    height: 8px;
  }

}

</style>